export default {"src":"/_next/static/media/v-symbol.d089a438.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};